import React from "react";

export default function ResearchStudyDetails() {
  return <div>ResearchStudyDetails</div>;
}
